import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import cn from 'classnames';
import style from "../common.module.scss"
import FilterIcon from '../../../shared/icons/FilterIcon';

const OrderItemFilter = ({ changeSortColumn, sortColumn = null }) => {
    const { t } = useTranslation(); // Initialize t function
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const onSortColumn = (keyField, order = 'asc') => {
        if (!sortColumn || sortColumn[keyField] !== order) {
            changeSortColumn({ [keyField]: order });
        } else {
            changeSortColumn(null);
        }
        setIsOpen(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div ref={dropdownRef} className={cn(style.dropdown, { [style.dropdown_active]: isOpen })}>
            <div onClick={() => { setIsOpen(!isOpen) }}>
                <FilterIcon />
                <span className={style.dropdown_title}>{t('orderItemFilter.sortTitle')}</span>
            </div>

            <div className={cn(style.dropdowns, { [style.dropdowns_open]: isOpen })}>
                <div className={style.dropdowns_item} onClick={() => onSortColumn('createdAt', sortColumn?.createdAt === 'asc' ? 'desc' : 'asc')}> {t('orderItemFilter.createdAt')} </div>
                <div className={style.dropdowns_item} onClick={() => onSortColumn('shippingDate', sortColumn?.shippingDate === 'asc' ? 'desc' : 'asc')}> {t('orderItemFilter.shippingDate')} </div>
                <div className={style.dropdowns_item} onClick={() => onSortColumn('unloadingDate', sortColumn?.unloadingDate === 'asc' ? 'desc' : 'asc')}>{t('orderItemFilter.unloadingDate')} </div>
                <div className={style.dropdowns_item} onClick={() => onSortColumn('price', 'desc')}> {t('orderItemFilter.priceDesc')} </div>
                <div className={style.dropdowns_item} onClick={() => onSortColumn('price', 'asc')}> {t('orderItemFilter.priceAsc')} </div>
                <div className={cn(style.dropdowns_item, style.dropdowns_reset)} onClick={() => { changeSortColumn(null), setIsOpen(false) }}> {t('orderItemFilter.reset')} </div>
            </div>
        </div>
    );
};

export default OrderItemFilter;
